import React, { Component } from "react";
import PropTypes from "prop-types";
import Overlay from "../Overlay";
import OverlayButton from "../OverlayButton";
import { EmailValidationError } from "../LoginErrors";
import { validateEmail, serialize } from "../App/utils";
import "./css/forgotPassword.css";

class ForgotPassword extends Component {
  constructor() {
    super();
    this.state = {
      errors: {
        emailFailedValidation: false,
        resetFailed: false
      },
      resetEmailSent: false,
      email: ""
    };
  }
  resetPassword(event) {
    const email = event.target.username.value;
    const request = new XMLHttpRequest();
    const data = {
      u: email
    };

    event.preventDefault();
    request.onreadystatechange = () => {
      if (request.readyState === 4 && request.status === 200) {
        this.setState({
          errors: {
            emailFailedValidation: false,
            resetFailed: false
          },
          email,
          resetEmailSent: true
        });
      } else if (request.readyState === 4 && request.status === 400) {
        this.setState({
          errors: {
            emailFailedValidation: false,
            resetFailed: true
          }
        });
      }
    };
    if (validateEmail(email)) {
      request.open(
        "POST",
        `${window.ENVCONFIG.legacy_api}/power/change-password`
      );
      request.setRequestHeader(
        "Content-Type",
        "application/x-www-form-urlencoded; charset=utf-8"
      );
      request.send(serialize(data));
    } else {
      this.setState({
        errors: {
          emailFailedValidation: true
        }
      });
    }
  }

  render() {
    return (
      <Overlay
        closeOverlay={this.props.closeOverlay}
        className={"reset-password"}
      >
        <h1>Reset Password</h1>
        {this.state.resetEmailSent ? (
          <h2 className="email-sent" data-quid="email-sent">
            An email has been sent to{" "}
            <span className="email">{this.state.email}</span>. Please follow the
            instructions to change your password.
          </h2>
        ) : (
          <div>
            <h2>
              To reset your password, please enter your email address below
            </h2>
            <form
              className="form-fields"
              onSubmit={evt => this.resetPassword(evt)}
            >
              {this.state.errors.emailFailedValidation && (
                <EmailValidationError />
              )}
              <input
                data-quid="user-name"
                type="text"
                className="user-name"
                name="username"
                placeholder="Email"
              />
              <button
                data-quid="back-to-signin"
                type="button"
                className="back-to-signin"
                onClick={() => this.props.showOverlay("login")}
              >
                back to sign in
              </button>
              <OverlayButton
                buttonType={"submit"}
                buttonText={"submit"}
                buttonClass={"red"}
                quid="reset-password-btn-submit"
              />
            </form>
          </div>
        )}
      </Overlay>
    );
  }
}

ForgotPassword.propTypes = {
  closeOverlay: PropTypes.func.isRequired,
  showOverlay: PropTypes.func.isRequired
};

ForgotPassword.defaultProps = {
  email: "dude@duder.com",
  errors: {}
};

export default ForgotPassword;
